import { useState } from "react";
import { useIonLoading } from "@ionic/react";
import {
    getInstallationFeedbackIsSent,
    postInstallationFeedback,
} from "../services/InstallationFeedbackService";
import { useAuth } from "../context/Auth";

export const useInstallationFeedback = () => {
    const { checkAxiosError } = useAuth();
    const [feedbackOriginallyAvailable, setFeedbackOriginallyAvailable] =
        useState<boolean>(true);
    const [feedbackSent, setFeedbackSent] = useState<boolean>(false);
    const [showLoader, dismissLoader] = useIonLoading();

    const fetchInstallationFeedbackIsSent = async (hash: string) => {
        await showLoader("Kérem várjon...");
        getInstallationFeedbackIsSent(hash)
            .then((res) => {
                setFeedbackOriginallyAvailable(res.data?.available ?? true);
            })
            .catch((err) => {
                checkAxiosError(err);
            })
            .finally(() => {
                dismissLoader();
            });
    };

    const sendInstallationFeedback = async (data: any) => {
        await showLoader("Visszajelzés küldése...");
        postInstallationFeedback(data)
            .then((res) => setFeedbackSent(true))
            .catch((err) => {
                checkAxiosError(err);
            })
            .finally(() => {
                dismissLoader();
            });
    };

    return {
        feedbackSent,
        feedbackOriginallyAvailable,
        fetchInstallationFeedbackIsSent,
        sendInstallationFeedback,
    };
};
